

  <ng-container *ngFor="let item of menuList; trackBy: trackMenu">
    <cub-left-menu-button [menuItem]="item"
                          [expanded]="activeMenu === item"
                          [selected]="!activeMenu && selectedMenuKey === trackMenu(0, item)"
                          (menuRequested)="toggleMenu(item, $event)"
                          (menuHovered)="hoverMenu(item, $event)"
                          (menuLeft)="scheduleClose()"
                          (menuClosed)="closeMenu()"></cub-left-menu-button>
  </ng-container>

  <ng-template cdkConnectedOverlay
               [cdkConnectedOverlayOrigin]="activeOrigin"
               [cdkConnectedOverlayOpen]="!!activeMenu"
               [cdkConnectedOverlayPositions]="positions"
               [cdkConnectedOverlayPush]="true"
               [cdkConnectedOverlayViewportMargin]="8"
               (overlayOutsideClick)="onOutsideClick($event)"
               (overlayKeydown)="onOverlayKeydown($event)">
    <cub-side-sub-menu [label]="activeMenu?.name ?? ''"
                       [menuList]="activeMenu?.subMenu ?? []"
                       [focusOnOpen]="!openedByHover"
                       (pointerEntered)="cancelPendingClose()"
                       (pointerLeft)="scheduleClose()"
                       (selected)="rememberSelection()"
                       (closed)="closeMenu()"></cub-side-sub-menu>
  </ng-template>
